module.exports = __webpack_public_path__ + "static/media/timesbi.e9f0868a.ttf";